/* eslint-disable global-require */
/* eslint-disable @typescript-eslint/no-var-requires */
import React, { FC, useEffect, useState } from 'react';
import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api';
import { useParams } from 'react-router-dom';
import { useToast } from '@chakra-ui/react';
import auth from '../../apis/auth';

type DataType = {
  deliveryMan: any;
  order: any;
};
type LocationType = {
  lat: number;
  lng: number;
};

const MapIndex: FC = () => {
  const { id }: any = useParams();

  const toast = useToast();

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: String(process.env.REACT_APP_GOOGLE_MAPS_API_KEY),
  });
  const [loaded, setLoaded] = useState(false);
  const [deliveryManLocation, setDeliveryManLocation] =
    useState<LocationType | null>(null);
  const [customerLocation, setCustomerLocation] = useState<LocationType | null>(
    null,
  );
  const [pickupLocation, setPickupLocation] = useState<LocationType | null>(
    null,
  );
  const [centerLocation, setCenterLocation] = useState<LocationType | null>(
    null,
  );

  const getMarkers = async () => {
    const { data } = await auth.get<DataType>(`/sode/location?order_id=${id}`);

    setDeliveryManLocation({
      lat: data.deliveryMan.latitude,
      lng: data.deliveryMan.longitude,
    });

    setCustomerLocation({
      lat: data.order.customer.latitude,
      lng: data.order.customer.longitude,
    });

    setPickupLocation({
      lat: data.order.pickup_address.latitude,
      lng: data.order.pickup_address.longitude,
    });

    return {
      lat: data.deliveryMan.latitude,
      lng: data.deliveryMan.longitude,
    };
  };

  const bootstrap = async () => {
    if (isLoaded) {
      try {
        setLoaded(true);
        const center = await getMarkers();
        setCenterLocation(center);
      } catch (err: any) {
        setLoaded(false);
        toast({
          title: 'Oops!',
          description: err.response.data.message ?? 'Ocorreu um erro os dados',
          status: 'error',
          position: 'top-right',
        });
      }
    } else {
      setLoaded(false);
    }
  };

  useEffect(() => {
    bootstrap();

    const interval = setInterval(() => {
      if (deliveryManLocation) {
        getMarkers();
      }
    }, 5000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ height: '100vh', width: '100%' }}>
      {loaded && (
        <GoogleMap
          center={
            centerLocation
              ? {
                  lat: Number(centerLocation.lat),
                  lng: Number(centerLocation.lng),
                }
              : { lat: -23.5505, lng: -46.6333 }
          }
          zoom={14}
          mapContainerStyle={{ height: '100%', width: '100%' }}
        >
          {deliveryManLocation && (
            <Marker
              position={{
                lat: Number(deliveryManLocation.lat),
                lng: Number(deliveryManLocation.lng),
              }}
              icon={{
                url: require('./deliveryMan.svg').default,
                scaledSize: new google.maps.Size(30, 30),
              }}
            />
          )}

          {customerLocation && (
            <Marker
              position={{
                lat: Number(customerLocation.lat),
                lng: Number(customerLocation.lng),
              }}
              icon={{
                url: require('./home.svg').default,
                scaledSize: new google.maps.Size(30, 30),
              }}
            />
          )}
          {pickupLocation && (
            <Marker
              position={{
                lat: Number(pickupLocation.lat),
                lng: Number(pickupLocation.lng),
              }}
              icon={{
                url: require('./pharmacy.svg').default,
                scaledSize: new google.maps.Size(30, 30),
              }}
            />
          )}
        </GoogleMap>
      )}
    </div>
  );
};

export default MapIndex;
